import React from "react";
import { useTranslation } from "react-i18next";
import {
  useEditProjectResource,
  useResourceRetrieval,
} from "@planzone/view-models";
import { ProjectResource } from "@planzone/dto";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Props } from "./types";
import { Form } from "./form";
import { InfoResource } from "./infoResource";
import styles from "./styles.scss";
import { Safeguard } from "@scenes/safeguard";
import { UseCases } from "@planzone/core";

function ProjectResourceEdition({ projectResource, cancel }: Props) {
  const { t } = useTranslation();
  const {
    isRequestPending: isResourceRetrievalPending,
    isRequestSuccess,
    isRequestFailure,
    resource,
    retrieveResource,
  } = useResourceRetrieval(projectResource.resource.uuid);
  const { isRequestPending, editProjectResource } =
    useEditProjectResource(projectResource);
  const [formData, setFormData] =
    React.useState<ProjectResource>(projectResource);

  React.useEffect(() => {
    !isResourceRetrievalPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveResource(projectResource.resource.uuid);
  }, [projectResource.resource.uuid]);

  React.useEffect(() => {
    setFormData(projectResource);
  }, [projectResource]);

  return (
    <Modal header={t("editProjectResource.title")} close={cancel}>
      <Safeguard useCases={[UseCases.editProjectResource]}>
        {({ canEditProjectResource }) => (
          <div className={styles.projectResourceEdition}>
            <div className={styles.body}>
              <InfoResource
                resource={
                  isRequestSuccess ? resource : projectResource.resource
                }
              />
              <Form
                formData={formData}
                isDisabled={!canEditProjectResource}
                editForm={setFormData}
              />
            </div>
            {canEditProjectResource && (
              <div className={styles.footer}>
                <Button type="cancel" press={cancel}>
                  {t("editProjectResource.cancel")}
                </Button>
                <Button
                  type={"submit"}
                  status={isRequestPending ? "pending" : "none"}
                  isDisabled={isRequestPending}
                  press={() =>
                    editProjectResource({
                      projectResource,
                      nextProjectResource: formData,
                    })
                  }
                >
                  {t("editProjectResource.save")}
                </Button>
              </div>
            )}
          </div>
        )}
      </Safeguard>
    </Modal>
  );
}

export { ProjectResourceEdition };
